/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import {translate} from 'react-i18next';
import {getTextColor} from './TextColorHelper';

class DayName extends React.Component {
	render() {
		const {isToday, position} = this.props;

		return (
			<div className={isToday ? 'activeDay' : 'inactiveDay'}>
				<p
					className='dayTitle'
					style={{
						color: getTextColor(this.props.day.state, true),
					}}
				>
					{this.props.t('overview:day').toUpperCase()}
				</p>
				<p
					className='dayDate'
					style={{
						color: getTextColor(this.props.day.state),
					}}
				>
					{position}
				</p>
			</div>
		);
	}
}

const styles = {
	headline: {
		fontWeight: 'bold',
	},
};

export default translate(['overview', 'common'])(DayName);



// WEBPACK FOOTER //
// ./src/overview/DayName.js